import { makeStyles } from '@mui/styles';
import MenuItem from 'apollo-react/components/MenuItem';
import Select from 'apollo-react/components/Select';
import React from 'react';

import { useTranslation } from '../../../../custom-hooks/useTranslation';
import { INPUT_MAX_HEIGHT } from '../constants';
import { relationalOperators } from '../operators';

const useStyles = makeStyles({
  root: {
    marginTop: 0,
    width: 134,
  },
  input: {
    maxHeight: INPUT_MAX_HEIGHT,
    minHeight: 0,
  },
  menuItem: {
    maxHeight: INPUT_MAX_HEIGHT,
  },
});

const RelationalOperatorSelect = ({ value, onChange, disabled, showLabel, ...props }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  return (
    <Select
      {...props}
      className={classes.root}
      InputProps={{
        inputProps: {
          className: classes.input,
        },
      }}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      label={showLabel ? translateString('Relational Operator') : null}
      placeholder={translateString('Relational Operator')}
      disabled={disabled}
      canDeselect={false}
    >
      {relationalOperators.map((operator) => (
        <MenuItem className={classes.menuItem} key={operator.id} value={operator.value}>
          {translateString(operator.text)}
        </MenuItem>
      ))}
    </Select>
  );
};

export default RelationalOperatorSelect;
